import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ApContentModule } from '@ap/content';
import { PegaMijnModule } from '@ap/pega';

import { ProductOpenenModule } from '../product-openen/product-openen.module';

import { MijnProductOpenenComponent } from './mijn-product-openen.component';

@NgModule({
    imports: [
        ApContentModule,
        PegaMijnModule,
        ProductOpenenModule,
        RouterModule.forRoot([], {
            useHash: false,
            enableTracing: false
        })
    ],
    exports: [MijnProductOpenenComponent],
    declarations: [MijnProductOpenenComponent],
    bootstrap: [MijnProductOpenenComponent]
})
export class MijnProductOpenenModule {}
